import { IDbNode } from "../_interface/IDbNode";
import { Types } from "../../utils/nodeTypes"
import { SingletonEnginnering } from "./singletonEngineering";
import { NumberFormat } from "../../utils/tools";

class MemoryRepository {
  constructor() {
    IDbNode.DbNode.apply(this, ["Repository"]);
    this.memory = new Array();
    this.addNode = (node) => this.memory.push(node)
    this.getNodeById = (id) => this.memory.filter(n => n.id == id);
    this.updateNode = (node) => this.memory.forEach(n => n = n.id == node.id ? node : n)
    
    this.getNodesToSave = () => this.memory.filter(n => n.type != new Types().Connection).map(n => n.clone())
    this.getPropertiesToSimulation = () => {
      let types = new Types()
      let inputNodes = this.memory.filter(n => {
        return types.inputNodes.includes(n.type) && n.type != types.InputCana || (n.type == types.InputCana && n.showBox)
      }
      ).reduce((acc, n) => {
        n.data.forEach(prop => acc.push(prop));
        return acc;
      }, []); 
      return inputNodes;
    }
    
    this.getProperties = () => {
      let properties = new Array();
      this.memory.forEach(n => {
        if(n.data && n.data.length > 0){
          n.data.forEach(p => properties.push(p))
        }
      })
      return properties;
    }

    this.resetPropertyValues = () => {
      let types = new Types()
      this.memory
        .filter(n => !types.inputNodes.includes(n.type))
        .forEach(n => {
          if(n.data && n.data.length > 0){
            n.data.forEach(p => p.value = "0,00")
          }
        });
    }

    this.reloadNodes = async () => {
      for(let j in this.memory){
        let node = this.memory[j];
        
        for(let i in node.data){
          let prop = node.data[i]
          node.data[i].value = NumberFormat(SingletonEnginnering.getValue(prop))
        }
        
        await this.memory[j].reloadProperties();
        this.memory[j].visibleApply();
      }
    }

    this.updateDataInNode = async (node, prop) => {
      try{
        let hasproperties = await node.hasPropertieOnData(prop)
        if(hasproperties){
          await node.updateData(prop)
          return true
        }
        return false
      }
      catch (e)
      {
        console.log(`Erro ao atualizar o nó:`, node)
        return false
      }
    }
        
    this.removeNode = async (id) => {
      let parentId;
      this.memory = this.memory.filter(n => {
          if (n.id == id) {
            if (n.parentId) parentId = n.parentId.split('-')[1];
            n.kill();
            return false;
          }
          return true;
      });
    
      if (parentId) {
        this.memory.forEach(n => n.id == parentId && n.removeConnection(id));
      }
    }

    this.getNodesBetween = (c) => {
      let x1
      let x2
      let y1
      let y2;

      if(c.x1 < c.x2)
      {
        x1 = c.x1
        x2 = c.x2
      }
      else
      {
        x1 = c.x2
        x2 = c.x1
      }
        
      if(c.y1 < c.y2)
      {
        y1 = c.y1
        y2 = c.y2
      }
      else
      {
        y1 = c.y2
        y2 = c.y1
      }

      return this.memory.filter(n => {
        let xOk = n.x >= x1 && n.x <= x2
        let yOk = n.y >= y1 && n.y <= y2
        if(xOk && yOk)
          return true;
        return false;
      })
    }
    
    this.clear = async () => {
      this.memory.forEach(n => n.kill());
      this.memory = new Array();
    }
  }
}

export { MemoryRepository };